import type { GessagemResult, ResultTableRow } from '../../../recommendations/types';

interface GessagemValues {
	S_g?: number;
	Ca_g?: number;
	satCa_g?: number;
}

export interface GessagemAdjustmentResponse extends GessagemValues {
	dose?: number;
	doseMax?: number;
	formaValue?: number;
}

export interface CalcularGessagemResponse {
	atual?: GessagemValues;
	interpretacao?: string;
	ajuste?: GessagemAdjustmentResponse;
}

export interface GessagemCalculationResult extends GessagemResult {
	interpretacao: string;
}

const numberString = (value: unknown): string => {
	if (value === null || value === undefined || value === '') return '';
	const numeric = Number(value);
	return Number.isFinite(numeric) ? String(numeric) : String(value);
};

const row = (param: string, unit: string, current: unknown, after: unknown): ResultTableRow => ({
	param,
	unit,
	current: numberString(current) || '—',
	range: '—',
	after: numberString(after) || '—',
});

export const mapGessagemAdjustment = (
	data: GessagemAdjustmentResponse,
	current?: GessagemValues,
	interpretacao = ''
): GessagemCalculationResult => ({
	doseMax: numberString(data.doseMax),
	interpretacao,
	ajuste: {
		dose: numberString(data.dose),
		doseSecundaria: numberString(data.formaValue),
	},
	table: [
		row('S_g', 'mg/dm³', current?.S_g, data.S_g),
		row('Ca_g', 'cmolc/dm³', current?.Ca_g, data.Ca_g),
		row('satCa_g', '%', current?.satCa_g, data.satCa_g),
	],
});

export const mapGessagemResponse = (data: CalcularGessagemResponse): GessagemCalculationResult =>
	mapGessagemAdjustment(data.ajuste ?? {}, data.atual, data.interpretacao ?? '');
